import { Dispatch } from 'redux'
import { handleInvalidSession } from 'api'

export const handleUnauthorizedEvent = (dispatch: Dispatch) => {
  const unauthorizedEventListener = (e: MessageEvent) => {
    if (e.data.type === 'UNAUTHORIZED') {
      handleInvalidSession('Unauthorized', dispatch, {
        clearSessionInfo: { needReturnUrl: false },
      })
    }
  }

  window.addEventListener('message', unauthorizedEventListener)

  return () => {
    window.removeEventListener('message', unauthorizedEventListener)
  }
}
